module.exports = __webpack_public_path__ + "img/mouth-2.ba648290.svg";